// extracted by mini-css-extract-plugin
export default {"form":"CritiqueForm_form__9eboy","error":"CritiqueForm_error__swd60","actions":"CritiqueForm_actions__Xhv-y"};